export default __webpack_public_path__ + "static/media/canine-I.128926f5.png";